import React from 'react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CentumVP } from 'components/hmilib/hooks/CentumVPScript';
import { pinnedLeftMenu } from '../../LeftMenu';
import ShSetup from '../SHSetup/ShSetup';
import PortableWindow from '../PortableWindow/PortableWindow';
import { createRoot } from 'react-dom/client';

interface INameInput {
    style?: React.CSSProperties;
}

const NameInput = (props: INameInput) => {
    const [inputNameValue, setInputNameValue] = useState<string>('');
    const [shSetupVisible, setShSetupVisible] = React.useState<boolean>(false);

    const menuAction = pinnedLeftMenu ? '' : 'CentumVP.close_left_menu();';

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputNameValue(event.target.value);
        CentumVP.save_input_value(event.target.value);
    };

    const handleInputKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleButtonClick();
        }
    };

    const handleButtonClick = () => {
        const Name = inputNameValue.toUpperCase();
        switch (Name) {
            case '.SH':
            case '.HR':
                CentumVP.open_faceplate(Name);
                break;
            default:
                CentumVP.set_name_input();
                break;
        }
    };

    function CloseShSetup() {
        setShSetupVisible(false);
    }

    return (
        <>
            <div style={props.style}>
                <div className="centumvp_left_panel_main_name">
                    <h3 style={{ color: '#ffffff', margin: '3px' }}>Name Input</h3>
                </div>
                <p className="centumvp_left_panel_main_inputs">
                    Window Name Input
                    <br />
                    <input
                        type="text"
                        size={30}
                        id="TextNameInput"
                        value={inputNameValue}
                        onChange={handleInputChange}
                        onKeyUp={handleInputKeyUp}
                    />
                    <input type="submit" value="CALL" onClick={handleButtonClick} />
                </p>
                <p>
                    <input type="checkbox" name="option1" value="a1" />
                    Default Station Information
                </p>
            </div>
            {/* {shSetupVisible && <ShSetup CloseSettings={CloseShSetup}/>} */}
        </>
    );
};

export default NameInput;
